// ============================================================================
// pig.dailys.detail — the pig daily record page
// ============================================================================
// pig.daily.detail is the page's own by-id read, moved off PigDailyPage.loadAll
// with the same projection and the same deleted_at filter, so opening a
// soft-deleted report still resolves to "not found" rather than to a row.
//
// pig.dailys.groupDirectory is shared with the hub — not because this page's
// own read demanded it, but because the ppp-feeders-v1 blob reached this page
// as a PigEntry prop forwarded through PigDailysRouter, and the router is where
// that hand-off has to be replaced. A catalog resource may only name surfaces
// the manifest declares migrated, so migrating the hub's dropdown alone would
// have left this page consuming a permanent resource it did not own.
//
// The record page's own writes (updateDailyReport, softDeleteDailyReport) touch
// no App-owned projection at all: a successful delete navigates back to the hub,
// which republishes the shared recent-dailys array from its own rows.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'pig.dailys.detail',
  obligations: Object.freeze([
    Object.freeze({id: 'pig.daily.detail', owner: 'permanent'}),
    Object.freeze({id: 'pig.dailys.groupDirectory', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
